import { render } from "./ForgotPasswordAlert.vue?vue&type=template&id=2797ea98"
import script from "./ForgotPasswordAlert.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__